import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private loaderElement: HTMLElement | null = null;

  constructor() { }

  showHideAutoLoader() {
    this.showLoader('This Loader Will Auto Hide in 2 Seconds');
    setTimeout(() => {
      this.hideLoader();
    }, 2000);
  }

  showLoader(message: string = 'Please wait...') {
    this.createOrUpdateLoader(message);
  }

  showLoaderLoading(message: string = 'Please wait...') {
    this.createOrUpdateLoader(message);
    const self = this;
    
    const mockLoader = {
      present: () => Promise.resolve(),
      dismiss: () => self.hideLoader(),
      onDidDismiss: () => Promise.resolve(),
      get message() {
        return message;
      },
      set message(newMessage: string) {
        message = newMessage;
        self.updateLoaderMessage(newMessage);
      }
    };
    
    return Promise.resolve(mockLoader as any);
  }

  async hideLoader() {
    if (this.loaderElement) {
      this.loaderElement.classList.add('opacity-0');
      const card = this.loaderElement.querySelector('#loader-card');
      if (card) {
        card.classList.remove('scale-100');
        card.classList.add('scale-95');
      }
      
      setTimeout(() => {
        if (this.loaderElement && this.loaderElement.parentNode) {
          this.loaderElement.parentNode.removeChild(this.loaderElement);
          this.loaderElement = null;
        }
      }, 300);
    }
  }


  async updateLoaderMessage(newMessage: string) {
    this.createOrUpdateLoader(newMessage);
  }

  private createOrUpdateLoader(message: string) {
    if (!this.loaderElement) {
      // Create full-screen backdrop
      this.loaderElement = document.createElement('div');
      this.loaderElement.className = 'fixed inset-0 z-[99999] flex items-center justify-center bg-slate-900/60 backdrop-blur-md transition-all duration-300 opacity-0 pointer-events-auto';
      
      this.loaderElement.innerHTML = `
        <div class="bg-white dark:bg-slate-900 px-10 py-8 rounded-[40px] shadow-2xl flex flex-col items-center space-y-6 border border-slate-100 dark:border-slate-800 transform transition-all duration-300 scale-90" id="loader-card">
          <div class="relative">
            <!-- Professional Spinner -->
            <div class="h-20 w-20 rounded-full border-4 border-primary-500/10 border-t-primary-500 animate-spin"></div>
            <div class="absolute inset-0 flex items-center justify-center">
              <div class="h-10 w-10 rounded-full bg-primary-500/10 animate-pulse"></div>
            </div>
          </div>
          
          <div class="text-center space-y-2">
            <span class="block text-xl font-bold text-slate-800 dark:text-white tracking-tight loader-message">${message}</span>
            <span class="block text-xs font-medium text-slate-400 dark:text-slate-500 uppercase tracking-widest animate-pulse">Processing...</span>
          </div>
        </div>
      `;
      
      document.body.appendChild(this.loaderElement);
      
      // Force reflow
      this.loaderElement.offsetHeight;
      
      requestAnimationFrame(() => {
        if (this.loaderElement) {
          this.loaderElement.classList.remove('opacity-0');
          const card = this.loaderElement.querySelector('#loader-card');
          if (card) {
            card.classList.remove('scale-90');
            card.classList.add('scale-100');
          }
        }
      });
    } else {
      const msgEl = this.loaderElement.querySelector('.loader-message');
      if (msgEl) {
        msgEl.textContent = message;
      }
    }
  }
}
